export const FETCH_DOCUMENT_ASSOCIATED_PROJECT_REQUEST = 'FETCH_DOCUMENT_ASSOCIATED_PROJECT_REQUEST'
export const FETCH_DOCUMENT_ASSOCIATED_PROJECT_SUCCESS = 'FETCH_DOCUMENT_ASSOCIATED_PROJECT_SUCCESS'
export const FETCH_DOCUMENT_ASSOCIATED_PROJECT_FALUIRE = 'FETCH_DOCUMENT_ASSOCIATED_PROJECT_FALUIRE'
